import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { token: String }
  connect() {
    this.sent = new Set()
    this.visibleSeconds = 0
    this.tick = () => {
      if (document.visibilityState !== "visible") return
      this.send("access")
      this.visibleSeconds += 1
      if (this.visibleSeconds >= 20 || location.pathname.startsWith("/estimate")) this.send("engaged")
    }
    this.input = (event) => {
      if (location.pathname === "/estimate" || event.target.closest('[data-controller~="estimate-modal"], [data-controller~="lp-estimate"]')) {
        if (event.target.matches("input:not([type=hidden]), select, textarea")) this.send("input_started")
      }
    }
    this.element.addEventListener("input", this.input)
    this.element.addEventListener("change", this.input)
    this.timer = setInterval(this.tick, 1000)
    this.tick()
  }
  disconnect() {
    clearInterval(this.timer)
    this.element.removeEventListener("input", this.input)
    this.element.removeEventListener("change", this.input)
  }
  async send(kind) {
    if (this.sent.has(kind) || !this.tokenValue) return
    this.sent.add(kind)
    try {
      const response = await fetch("/posting/events", { method: "POST", credentials: "same-origin", headers: {
        "Content-Type": "application/json", "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
      }, body: JSON.stringify({ token: this.tokenValue, kind }) })
      if (response.status >= 500) this.sent.delete(kind)
    } catch (_) { this.sent.delete(kind) }
  }
}
